import { useState } from 'react'
import MobileScanMockup from './MobileScanMockup'
import type { HowLabels } from '@/pages/landing/types'

export default function HowItWorks({ labels }: { labels: HowLabels }) {
  const [active, setActive] = useState(0)

  return (
    <section className="py-[76px] px-[22px]">
      <div className="max-w-[1080px] mx-auto">
        <div className="max-w-[46ch] mx-auto text-center mb-11">
          <span className="font-script text-flame text-xl inline-block -rotate-1">{labels.eyebrow}</span>
          <h2 className="font-body font-extrabold text-ink text-3xl md:text-4xl tracking-tight mt-1">{labels.title}</h2>
        </div>

        <div className="grid lg:grid-cols-[1.15fr_0.85fr] gap-11 items-center">
          <div className="flex flex-col gap-4">
            {labels.steps.map((step, i) => {
              const isActive = i === active
              return (
                <button
                  key={i}
                  type="button"
                  onClick={() => setActive(i)}
                  aria-pressed={isActive}
                  className={`flex items-start gap-[18px] text-left rounded-[16px] p-[22px] border-2 transition-all cursor-pointer ${
                    isActive
                      ? 'bg-card border-ink shadow-hard'
                      : 'bg-card border-line shadow-soft hover:border-ink/40'
                  }`}
                >
                  <span className={`font-script text-[2.2rem] leading-none shrink-0 ${isActive ? 'text-flame' : 'text-ink-faint'}`}>{step.number}</span>
                  <div>
                    <h3 className="font-body font-extrabold text-lg text-ink mb-1">{step.title}</h3>
                    <p className="text-sm text-ink-soft leading-relaxed">{step.description}</p>
                  </div>
                </button>
              )
            })}
          </div>
          <div className="shrink-0">
            <MobileScanMockup step={active} labels={labels.phone} />
          </div>
        </div>
      </div>
    </section>
  )
}
